import usersService from '../services/users';
import useAsyncList from './useAsyncList';

/** Pass as appId to list active users across every app (portal-admin user pickers). */
export const ALL_APPS = 'all';

/**
 * Users of an app, for pickers and id -> name lookups.
 * @param {string} appId an app id, or ALL_APPS for active users across all apps
 * @param {{ enabled?: boolean }} [opts] pickers inside modals pass enabled=<modal open>,
 *   which also refetches each time the modal opens
 * @returns {{ items: object[], byId: Record<string, object>, loading: boolean, error: string, reload: () => void }}
 */
export default function useAppUsers(appId, { enabled = true } = {}) {
    return useAsyncList(
        () => (appId === ALL_APPS ? usersService.getAllActiveUsersAcrossApps() : usersService.getAll(appId)),
        {
            key: appId || '',
            enabled,
            idKey: 'user_id',
            errorMessage: 'Couldn’t load users.',
        }
    );
}
